import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/bulma.min.css';
import './assets/css/bulma-switch.min.css';
import './assets/css/style.css';
import './assets/css/theme.css';
import '../node_modules/intro.js/introjs.css';
// import MainPage from './components/MainPage';
import './i18n';


ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
